
export class SharePointSite {
  id: string;
  name: string;
  parentId: string;
  isList: boolean;
  providerInstanceResourceId: string|null;
}
